import { GlobalHeaderRight } from '@/components/right-content';
import { HooksService } from '@shoppykey/hook';
import { logs } from '@shoppykey/tools';
import { history, RunTimeLayoutConfig } from '@umijs/max';
import _ from 'lodash';
import { themeSettings } from '../config/theme-settings';
import Footer from './components/footer';
import './global.less';
import type { CurrentUser, GlobalData } from './schema/global-data';
import { Fetch } from './utils/fetch';
const ignorePathList = [
  '/auth/login',
  '/auth/sso',
  '/auth/register',
  '/auth/forget',
  '/auth/transfer',
  '/auth/transfer/enterPassword',
];

async function fetchUserInfo() {
  const info = await Fetch.get<CurrentUser>(`/api/current-user`);
  return info;
}

export async function getInitialState(): Promise<GlobalData> {
  const hooksService = new HooksService();
  // 如果是登录页面，不执行
  if (!_.includes(ignorePathList, history.location.pathname)) {
    try {
      const currentUser = await fetchUserInfo();
      return {
        currentUser,
        settings: themeSettings,
        hooksService,
      };
    } catch (error) {
      logs.warn(error);
    }
  }
  return {
    settings: themeSettings,
    hooksService,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    rightContentRender: () => <GlobalHeaderRight />,
    disableContentMargin: false,
    footerRender: () => <Footer />,
    logo: () => {
      return <img src="/logo.svg" alt="" />;
    },
    token: {
      pageContainer: {
        paddingBlockPageContainerContent: 12,
        paddingInlinePageContainerContent: 24,
      },
      sider: {
        colorMenuBackground: '#fff',
        colorMenuItemDivider: '#dfdfdf',
        colorTextMenu: '#595959',
      },
    },
    ...initialState?.settings,
  };
};
